export default {
  dbi_market: '市场',
  dbi_market_profile: '市场简介',
  dbi_market_annual_report: '年报',
  dbi_market_global_perf: '全球表现',
  dbi_market_dataai: '数据直接来自 data.ai 市场规模终端。',
  dbi_market_newzoo_rev:
    '这里显示的是内部产生的年度总收入，只应用时间筛选器里的年份',
  dbi_market_newzoo_player:
    '这里显示的是内部产生的年度总下载，只应用时间筛选器里的年份',
  dbi_market_global_sum: '全球游戏市场概述',
  dbi_market_distribution: '全球游戏市场分布',
  dbi_market_game_count: '游戏数量',
  dbi_market_gdp: '额定国内生产总值',
  dbi_market_gdp_per: '人均国内生产总值',
  dbi_market_gdp_intro:
    '人均国内生产总值 (GDP) 是一种金融指标，用于衡量一个国家的人均经济产出，计算方法是将一个国家的 GDP 除以其人口。',
  dbi_market_total_pop: '人口总数',
  dbi_market_online_pop: '在线人口',
  dbi_market_total: '市场总额',
  dbi_market_mobile: '移动游戏市场',
  dbi_market_pc: 'PC游戏市场',
  dbi_market_console: '主机游戏市场',
  dbi_mobile_game: '移动游戏',
  dbi_pc_game: 'PC游戏',
  dbi_console_game: '主机游戏',
  dbi_market_perf_sum: '市场表现概述',
  dbi_market_perf_sum_tip:
    'PC和Console端游的线上收入数据仅支持美英法德西5个国家，线下收入数据仅支持美国。',
  dbi_market_blockbuster: '新爆款游戏',
  dbi_total_rev: '总收入',
  dbi_total_rev_$: '总收入(美元)',
  dbi_total_player: '总玩家数',
  dbi_market_percent: '市场占比',
  dbi_market_percent_revenue: '收入市场占比',
  dbi_market_percent_downloads: '下载市场占比',
  dbi_market_top_game: '热门游戏',
  dbi_market_top_company: '热门公司',
  dbi_market_big_riser: '突增榜',
  dbi_market_cr10: '按收入前10划分的市场',
  dbi_market_big_riser_tips_mobile:
    '突增游戏(Big Riser Games)取自首次进入App Store商店各榜单的游戏。',
  dbi_market_big_riser_tips_pc:
    '突增游戏(Big Riser Games)取自首次进入Steam Top Seller榜单、Mscience收入排名头部以及MAU排名头部的游戏。',
  dbi_market_big_riser_tips_console:
    '突增游戏(Big Riser Games)取自首次进入PS Best Selling榜单、PS Most Downloaded榜单、Xbox Most Played榜单、Xbox New Release榜单的游戏。',
  dbi_market_blockbuster_mobile_tip:
    '手游: 重磅新游(New Blockbuster Games)选自近期发布上线的突增游戏(Big Riser Games)，突增游戏取自首次进入App Store商店各榜单的游戏。',
  dbi_market_blockbuster_pc_tip:
    'PC端游: 重磅新游(New Blockbuster Games)选自近期发布上线的突增游戏(Big Riser Games)，突增游戏取自首次进入Steam Top Seller榜单、Mscience收入排名头部以及MAU排名头部的游戏',
  dbi_market_blockbuster_console_tip:
    '主机端游: 重磅新游(New Blockbuster Games)选自近期发布上线的突增游戏(Big Riser Games)，突增游戏取自首次进入PS Best Selling榜单、PS Most Downloaded榜单、Xbox Most Played榜单、Xbox New Release榜单的游戏。',
  dbi_market_operation_data: '运营数据',
  dbi_market_by_game: '按游戏',
  dbi_market_by_genres: '按品类',
  dbi_market_by_companies: '按公司',
  dbi_market_by_main_genre: '按主品类',
  dbi_market_by_sub_genre: '按副品类',
  dbi_market_tip_text: '移动指标来自 Databrain 数据库中的所有可用游戏。',
  dbi_market_tip_text_mscience: 'Mscience日粒度数据仅适用于美国。',
  dbi_market_gender: '性别',
  dbi_market_male: '男',
  dbi_market_female: '女',
  dbi_market_other: '其他',
  dbi_market_age_combined: '年龄',
  dbi_market_education: '教育程度',
  dbi_market_low: '低',
  dbi_market_middle: '中',
  dbi_market_high: '高',
  dbi_market_Other_no_answer: '其他/不愿回答',
  dbi_market_work_situation: '工作情况',
  dbi_market_full_time_employee: '全职雇员',
  dbi_market_part_time_employee: '兼职雇员',
  dbi_market_independent: '创业者',
  dbi_market_homemaker: '全职家庭主妇',
  dbi_market_student: '学生',
  dbi_market_unemployed: '失业者',
  dbi_market_Retired: '退休人员',
  dbi_market_furloughed: '延长或当前休假',
  dbi_market_esport_audience: '电竞受众',
  dbi_market_esport_enthusiasts: '电竞爱好者',
  dbi_market_occasional_viewers: '偶尔观看者',
  dbi_market_non_esport_audience: '非电竞观众',
  dbi_market_players: '玩家',
  dbi_market_total_players: '玩家总数',
  dbi_market_non_total_players: '非总玩家',
  dbi_market_mobile_players: '手游玩家',
  dbi_market_non_mobile_players: '非手游玩家',
  dbi_market_pc_players: '端游玩家',
  dbi_market_non_pc_players: '非端游玩家',
  dbi_market_console_players: '主机玩家',
  dbi_market_non_console_players: '非主机玩家',
  dbi_market_income: '收入',
  dbi_market_persona: '角色',
  dbi_market_ultimate_gamer: '终极玩家',
  dbi_market_all_enthusiast: '全能发烧友',
  dbi_market_mainstream_gamer: '主流玩家',
  dbi_market_community_gamer: '社区玩家',
  dbi_market_solo_gamer: '单机游戏玩家',
  dbi_market_popcorn_gamer: '爆米花玩家',
  dbi_market_backseat_viewer: '场外乡民',
  dbi_market_time_filler: '杀时间玩家',
  dbi_market_lapsed_gamer: '业余玩家',
  dbi_market_bargain_buyer: '经济型玩家',
  dbi_market_hardware_enthusiast: '硬件发烧友',
  dbi_market_not_persona: '玩家类型不明',
  dbi_market_total_popular: '总人口',
  dbi_market_online_population: '在线人口',
  dbi_market_top_genre: '品类表现',
  dbi_market_age: '年龄',
  dbi_market_total_game: '总游戏数量',
  dbi_search_in_table: '在表格里搜索任何{type}',
  dbi_market_revenue_data_tip:
    '在观察内部数据后，MScience上美国的收入和销售额数据被修正为原来的一半。',
  dbi_market_global_tip: `这里显示的是全球市场的总值，而不是下表中所有市场的累计值。`,

  dbi_market_profile_metric_tips_gsd__gsd_totalUnits:
    '总销量 = 线上销量 + 零售销量，GSD并不直接提供此指标。总销量1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_gsd__gsd_digitalUnits:
    '游戏电子版销量。由头部发行商直接向GSD分享的数据。电子版销量仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_gsd__gsd_physicalUnits:
    '游戏零售版销量。由头部发行商直接向GSD分享的数据。零售版销量仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_gsd__gsd_totalRevenue:
    '总收入 = 游戏线上收入 + 游戏零售版收入，GSD并不直接提供此指标。 总收入数据可能会因时间段不同而有所差异，因为零售收入有1周的延迟，而线上收入则有12周的延迟。数据且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_gsd__gsd_digitalRevenue:
    '游戏电子版收入。由头部发行商直接向GSD分享的数据。电子版收入有12周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_gsd__gsd_physicalRevenue:
    '游戏零售版收入。由头部发行商直接向GSD分享的数据。零售版收入仅1周延迟，且为考虑退款部分后的净收入。注意，除UK数据外，周粒度数据均从周一开始至周日。取所选时间范围内的总值。',
  dbi_market_profile_metric_tips_mscience__digitalRevenue:
    '线上购买的电子版游戏总收入。取所选时段范围内总值。',
  dbi_market_profile_metric_tips_mscience__units:
    '线上购买的电子版游戏总销量。取所选时段范围内总值。',
  dbi_market_profile_metric_tips_npd__revenue:
    '线下零售购买的硬件版游戏总收入。取所选时间段内的总值。',
  dbi_market_profile_metric_tips_npd__units:
    '线下零售购买的硬件版游戏总销量。取所选时间段内的总值。',
  dbi_market_profile_metric_tips_newzoo__total_revenue:
    '这里显示的是内部产生的年度总收入，只应用时间筛选器里的年份。',
  dbi_market_profile_metric_tips_newzoo__total_players:
    '这里显示的是内部产生的年度总下载，只应用时间筛选器里的年份。',
};
